import {useDispatch, useSelector} from 'react-redux'
import styled from '@emotion/styled'
import useShowOverlay from 'hooks/useShowOverlay/useShowOverlay'
import {getHowSearchWorkOverlay} from 'modules/overlay/selectors'
import {hideOverlay} from 'modules/overlay/slice'
import {OverlayType} from 'modules/overlay/types'

import {Box} from '@vio/atlas/helpers/Box'
import {Icon} from '@vio/atlas/Icon'
import {OverlayPage, OverlayPageContent} from '@vio/atlas/OverlayPage'
import {PopUp} from '@vio/atlas/PopUp'
import {useDeviceLayout} from '@vio/atlas/src/context/deviceLayout'
import {Text} from '@vio/atlas/Text'
import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {Action, Category, Entity} from '@vio/core/src/analytics/types/Events'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {HowSearchWorksContent} from './HowSearchWorksContent'

const POPUP_WIDTH = 896

const InfoText = styled(Text)`
  user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;
`

export const HowSearchWorks = () => {
  const isOpen = useSelector(getHowSearchWorkOverlay)
  const {isDesktop} = useDeviceLayout()
  const showOverlay = useShowOverlay()

  const dispatch = useDispatch()

  const handleOpen = () => {
    showOverlay({type: OverlayType.HowSearchWorks})
    dispatch(
      trackEvent({
        category: Category.User,
        entity: Entity.HowSearchWorksText,
        action: Action.Clicked
      })
    )
  }

  const handleClose = () => {
    dispatch(hideOverlay())
  }

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        width="fit-content"
        gap="s100"
        marginLeft={isDesktop ? 's300' : 's000'}
        marginBottom={isDesktop ? 's000' : 's400'}
        cursor="pointer"
        onClick={handleOpen}
      >
        <InfoText variant="bodyXS">
          <FormattedMessageWrapper
            id="howSearchWorks.whyResultsAppearThisWay"
            defaultMessage="Why results appear this way"
          />
        </InfoText>
        <Icon size="sm" colorPath="neutral.c600" name="Information" />
      </Box>
      {isDesktop ? (
        <PopUp
          noPaddings
          isOpen={isOpen}
          width={POPUP_WIDTH}
          closeAction={handleClose}
          navBarProps={{
            centerContent: <HeaderCenterContent />,
            withDivider: true
          }}
        >
          <HowSearchWorksContent isOpen={isOpen} />
        </PopUp>
      ) : (
        <OverlayPage
          navBarProps={{
            centerContent: <HeaderCenterContent />
          }}
          hasHeaderBoxShadow
          isOpen={isOpen}
          onClose={handleClose}
        >
          <OverlayPageContent>
            <HowSearchWorksContent />
          </OverlayPageContent>
        </OverlayPage>
      )}
    </>
  )
}

const HeaderCenterContent = () => {
  return (
    <Box display="flex" alignItems="center" gap="s300">
      <Icon colorPath="neutral.c200" name="Search" />
      <FormattedMessageWrapper
        id="howSearchWorks.whyResultsAppearThisWay"
        defaultMessage="Why results appear this way"
      />
    </Box>
  )
}
